/*    
<summary>
  This functional component "ClientFilterForm" provides form to get data based on filter
  Developer:Aashish Singh, Created Date:20-March-2024
</summary>
<returns>Returns JSX</returns>
*/
import { Field, Form, Formik, useFormikContext } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import {
  DATE_FORMAT_BACKEND,
  reportFileTypes,
} from "../../../constants/common-constant";
import { TransactionReportTypeEnum } from "../../../constants/enums/transaction-report-type-enum";
import UserType from "../../../constants/userType.constant";
import { useStore } from "../../../contexts/StoreProvider";
import {
  getCustomerId,
  getUserType,
} from "../../../helpers/localStorages.helper";
import {
  IAddReport,
  IReportInfo,
} from "../../../models/response/IReportResponse";
import { ISelectOption } from "../../../models/response/ITruckResponse";
import LoaderButton from "../../../shared-components/Button/LoaderButton";
import DraggableModal from "../../../shared-components/Draggable/DraggableModal";
import FormikFormInputMultipleSelect from "../../../shared-components/FormikFormHandlers/formik-form-multi-select-input";
import FormikFormDateTimePicker from "../../../shared-components/FormikFormHandlers/FormikFormDateTimePicker";
import FormikFormInput from "../../../shared-components/FormikFormHandlers/FormikFormInput";
import FormikFormSelectField from "../../../shared-components/FormikFormHandlers/FormikFormSelectField";
import {
  summaryReportValidateSchema,
  transactionPaymentReportValidateSchema,
  transactionReportValidateSchema,
} from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import Label from "../../../shared-components/label/label";
import { IOption } from "../../../core/initialState/initial-filter-states";
import FormikDateFieldMUI from "../../../shared-components/FormikFormHandlers/FormikFormDatePickerMUI";

interface IProps {
  submitHandler: (values: any) => void;
  onModalClosed: () => void;
  actionInProgress: boolean;
  initialValues: IReportInfo;
  idLabel: string;
  transactionReportType: TransactionReportTypeEnum;
  label: string;
  IdOptions: ISelectOption[];
  CustomerIdOptions: ISelectOption[];
  reportTypeOptions: IOption[];
}

const ReportsFilterForm = (props: IProps) => {
  const { preferencesStore } = useStore();
  const {
    initialValues,
    submitHandler,
    onModalClosed,
    actionInProgress,
    idLabel,
    transactionReportType,
    label,
    IdOptions,
    CustomerIdOptions,
    reportTypeOptions,
  } = props;
  const date = new Date();
  const startDate: Date = new Date(
    date.setHours(0, 0, 0, 0) - 7 * 24 * 60 * 60 * 1000
  );
  const endDate: Date = new Date(date.setHours(23, 59, 59, 999));
  const [dateFilter, setDateFilter] = useState<{
    startDate: Date;
    endDate: Date;
  }>({ startDate: startDate, endDate: endDate });
  const [isGlobalFilterChanged, setIsGlobalFilterChanged] =
    useState<boolean>(false);
  const [selectedSearchId, setSelectedSearchId] = useState<string>("");

  const FormObserver: React.FC = () => {
    const { values, setFieldValue } = useFormikContext<IReportInfo>();

    useEffect(() => {
      if (
        ((getUserType() === UserType.CustomerAdmin ||
          getUserType() === UserType.CustomerUser) &&
          transactionReportType === TransactionReportTypeEnum.VEHICLE_WISE) ||
        transactionReportType ===
          TransactionReportTypeEnum.CUSTOMER_WISE_SUMMARY ||
        transactionReportType === TransactionReportTypeEnum.CONSUMPTION_WISE ||
        transactionReportType ===
          TransactionReportTypeEnum.CONSUMPTION_WISE_SUMMARY
      ) {
        console.log(CustomerIdOptions, getCustomerId());
        let customerId = CustomerIdOptions.filter(
          (customer: ISelectOption) =>
            customer.id === Number(getCustomerId() ?? -1)
        )[0];
        setFieldValue("CustomerId", [customerId ?? -1]);
      }
    }, [CustomerIdOptions, getCustomerId, setFieldValue]);

    useEffect(() => {
      if (
        (getUserType() === UserType.CustomerAdmin ||
          getUserType() === UserType.CustomerUser) &&
        (transactionReportType === TransactionReportTypeEnum.CUSTOMER_WISE ||
          transactionReportType === TransactionReportTypeEnum.PAYMENT_WISE ||
          transactionReportType ===
            TransactionReportTypeEnum.CUSTOMER_WISE_SUMMARY ||
          transactionReportType ===
            TransactionReportTypeEnum.CONSUMPTION_WISE ||
          transactionReportType ===
            TransactionReportTypeEnum.CONSUMPTION_WISE_SUMMARY)
      ) {
        let customerId = IdOptions.filter((customer: ISelectOption) => {
          return customer.id === Number(getCustomerId() ?? -1);
        })[0];
        if (
          transactionReportType ===
            TransactionReportTypeEnum.CUSTOMER_WISE_SUMMARY ||
          transactionReportType ===
            TransactionReportTypeEnum.CONSUMPTION_WISE ||
          transactionReportType ===
            TransactionReportTypeEnum.CONSUMPTION_WISE_SUMMARY
        ) {
          let custId = {
            id: customerId?.id,
            value: customerId?.label,
            label: customerId?.label,
            disabled: false,
            data: {
              Id: customerId?.id,
              Name: customerId?.label,
            },
            topic: "",
          };
          setFieldValue("SearchId", [custId?.value ?? ""]);
        } else {
          setFieldValue("SearchId", [customerId ?? -1]);
        }
      }
    }, [setFieldValue]);

    // useEffect(() => {
    //   if (values.SearchId !== selectedSearchId) {
    //     setSelectedSearchId(values.SearchId);
    //     setFieldValue(
    //       "FileName",
    //       transactionReportType !== TransactionReportTypeEnum.PAYMENT_WISE
    //         ? values.SearchId
    //         : `${values.SearchId}_payment`
    //     );
    //   }
    // }, [values.SearchId, setFieldValue]);
    return null;
  };

  return (
    <>
      <Modal
        className="add-user-modal generate-report"
        show={true}
        centered
        dialogAs={DraggableModal}
      >
        <Modal.Header>
          <Modal.Title>
            <FormattedMessage id="generate_report" />
          </Modal.Title>
          <div onClick={onModalClosed} className="icons8-close">
            <span className="material-symbols-outlined fs-5 text-dark">
              close
            </span>
          </div>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={
            transactionReportType === TransactionReportTypeEnum.PAYMENT_WISE
              ? transactionPaymentReportValidateSchema
              : transactionReportType ===
                  TransactionReportTypeEnum.CONSUMPTION_WISE ||
                transactionReportType ===
                  TransactionReportTypeEnum.CONSUMPTION_WISE_SUMMARY ||
                transactionReportType ===
                  TransactionReportTypeEnum.CUSTOMER_WISE_SUMMARY
              ? summaryReportValidateSchema
              : transactionReportValidateSchema
          }
          enableReinitialize
          onSubmit={async (values: any) => {
            let isAllOptionSelected = values.SearchId.filter(
              (gp: ISelectOption) => gp.id === -1
            );
            let selectedGroupIdList: any =
              isAllOptionSelected.length > 0
                ? [...props.IdOptions]
                    .filter((as) => as.id !== -1)
                    .map((gp: ISelectOption) => gp)
                : [...values.SearchId].map((gp: ISelectOption) => gp);
            let data: IAddReport = {
              SearchId:
                transactionReportType ===
                  TransactionReportTypeEnum.CUSTOMER_WISE_SUMMARY ||
                transactionReportType ===
                  TransactionReportTypeEnum.CONSUMPTION_WISE_SUMMARY ||
                transactionReportType ===
                  TransactionReportTypeEnum.CONSUMPTION_WISE
                  ? selectedGroupIdList
                  : selectedGroupIdList.map(
                      (asset: ISelectOption) => asset.value
                    ),
              Month: values.Month
                ? moment(
                    (values.Month.$d as Date) ? values.Month.$d : values.Month
                  )
                    .utc()
                    .toISOString()
                : "",
              StartDate: values.StartDate
                ? moment(
                    (values.StartDate.$d as Date)
                      ? values.StartDate.$d
                      : values.StartDate
                  )
                    .utc()
                    .toISOString()
                : "",
              EndDate: values.EndDate
                ? moment(
                    (values.EndDate.$d as Date)
                      ? values.EndDate.$d
                      : values.EndDate
                  )
                    .utc()
                    .toISOString()
                : "",
              FileName: values.FileName
                ? values.FileName.trim()
                : values.FileName,
              ReportType: transactionReportType,
              ActionType: values.ActionType,
              CustomerId:
                transactionReportType ===
                  TransactionReportTypeEnum.VEHICLE_WISE && values.CustomerId
                  ? values.CustomerId.map((asset: ISelectOption) => asset.value)
                  : [],
            };
            let paymentData: IAddReport = {
              SearchId: selectedGroupIdList.map(
                (asset: ISelectOption) => asset.value
              ),
              CustomerId: values.CustomerId,
              StartDate: values.StartDate
                ? moment(
                    (values.StartDate.$d as Date)
                      ? values.StartDate.$d
                      : values.StartDate
                  )
                    .utc()
                    .toISOString()
                : "",
              EndDate: values.EndDate
                ? moment(
                    (values.EndDate.$d as Date)
                      ? values.EndDate.$d
                      : values.EndDate
                  )
                    .utc()
                    .toISOString()
                : "",
              FileName: values.FileName
                ? values.FileName.trim()
                : values.FileName,
              ReportType: transactionReportType,
              ActionType: values.ActionType,
            };
            submitHandler(
              transactionReportType !== TransactionReportTypeEnum.PAYMENT_WISE
                ? data
                : paymentData
            );
          }}
        >
          {({ values, setFieldValue }) => {
            console.log(values.SearchId, values.CustomerId);
            return (
              <Form className="user-form p-3" noValidate>
                <FormObserver />
                <Modal.Body>
                  <Row>
                    {/* <Col xs={12} className="mb-3 alarm-datepicker">
                    <Label className="form-label mt-2 pt-1 mb-0"
                      label={formatMessage("")} />
                  </Col> */}
                    {!(
                      transactionReportType ===
                        TransactionReportTypeEnum.CUSTOMER_WISE_SUMMARY ||
                      transactionReportType ===
                        TransactionReportTypeEnum.CONSUMPTION_WISE ||
                      transactionReportType ===
                        TransactionReportTypeEnum.CONSUMPTION_WISE_SUMMARY
                    ) ? (
                      <>
                        <Col xs={6} className="alarm-datepicker">
                          <div className="form-group datepicker-transaction">
                            <Label
                              className="form-label"
                              // required={true}
                              label="transactions_label_starttime"
                            />
                            {/* <Field
                            className="form-control"
                            aria-label="Default select example"
                            name="TsGen"
                            as={FormikFormDateTimePicker}
                          /> */}
                            <Field
                              name="StartDate"
                              as={FormikFormDateTimePicker}
                              // label="From"
                              ampm="false"
                              // max={getCurrentDateTime()}
                            />
                          </div>

                          {/* <DateRangeFilter dateFilterHandler={setDateFilter} setIsGlobalFilterChanged={setIsGlobalFilterChanged} isGlobalFilterChanged={isGlobalFilterChanged} dateFilter={dateFilter} /> */}
                        </Col>
                        <Col xs={6} className="alarm-datepicker">
                          <div className="form-group datepicker-transaction">
                            <Label
                              className="form-label"
                              // required={true}
                              label="transactions_label_endtime"
                            />
                            {/* <Field
                            className="form-control"
                            aria-label="Default select example"
                            name="TsGen"
                            as={FormikFormDateTimePicker}
                          /> */}
                            <Field
                              name="EndDate"
                              as={FormikFormDateTimePicker}
                              // label="From"
                              ampm="false"
                              // max={getCurrentDateTime()}
                            />
                          </div>

                          {/* <DateRangeFilter dateFilterHandler={setDateFilter} setIsGlobalFilterChanged={setIsGlobalFilterChanged} isGlobalFilterChanged={isGlobalFilterChanged} dateFilter={dateFilter} /> */}
                        </Col>
                      </>
                    ) : (
                      <Col lg={12} md={12} xs={12} className="mb-2">
                        <div className="form-group date-picker-error">
                          <Label
                            className="form-label"
                            required={true}
                            label="month"
                          />
                          <Field
                            name="Month"
                            as={FormikDateFieldMUI}
                            max={moment(new Date()).format(DATE_FORMAT_BACKEND)}
                            isMonthPicker={+true}
                          />
                        </div>
                      </Col>
                    )}

                    {
                      <Col xs={12}>
                        <div className="form-group mb-3">
                          <Label
                            className="form-label"
                            label={
                              transactionReportType !==
                              TransactionReportTypeEnum.PAYMENT_WISE
                                ? idLabel
                                : "customer_id"
                            }
                            required={true}
                          />
                          {transactionReportType ===
                            TransactionReportTypeEnum.CUSTOMER_WISE_SUMMARY ||
                          transactionReportType ===
                            TransactionReportTypeEnum.CONSUMPTION_WISE_SUMMARY ||
                          transactionReportType ===
                            TransactionReportTypeEnum.CONSUMPTION_WISE ? (
                            <Field
                              className="form-control"
                              name="SearchId"
                              placeholder={"customer_id"}
                              isName={true}
                              as={FormikFormSelectField}
                              options={[
                                { Name: "please_select", Id: -1 },
                                ...props.CustomerIdOptions.filter(
                                  (option) => option.id !== -1
                                ).map((op) => {
                                  return { Name: op.value, Id: op.id };
                                }),
                              ]}
                              isChangeSummaryHandler={+true}
                            />
                          ) : (
                            <Field
                              name="SearchId"
                              className="react-select-parent"
                              isMulti={true}
                              isSearchable={true}
                              isDisabled={
                                (getUserType() === UserType.CustomerAdmin ||
                                  getUserType() === UserType.CustomerUser) &&
                                (transactionReportType ===
                                  TransactionReportTypeEnum.CUSTOMER_WISE ||
                                  transactionReportType ===
                                    TransactionReportTypeEnum.PAYMENT_WISE)
                                  ? true
                                  : false
                              }
                              isLoading={false}
                              isClearable={true}
                              isSelectAsset={+true}
                              placeholder={
                                transactionReportType !==
                                TransactionReportTypeEnum.PAYMENT_WISE
                                  ? idLabel
                                  : "customer_id"
                              }
                              invalidcharacter={[" "]}
                              validcharacter={["_"]}
                              options={
                                values?.SearchId?.length > 0
                                  ? values?.SearchId?.findIndex(
                                      (item: any) => item.id === -1
                                    ) !== -1
                                    ? [props.IdOptions[0]]
                                    : props.IdOptions.filter(
                                        (item: any) => item.id !== -1
                                      )
                                  : props.IdOptions ?? []
                              }
                              // options={
                              // UserType.CustomerAdmin === getUserType() &&
                              // transactionReportType ===
                              //   TransactionReportTypeEnum.PAYMENT_WISE
                              //   ? IdOptions.filter((e) => e.Id > 0)
                              //   : IdOptions
                              // }
                              as={FormikFormInputMultipleSelect}
                            />
                          )}
                        </div>
                      </Col>
                    }
                    {transactionReportType ===
                      TransactionReportTypeEnum.VEHICLE_WISE && (
                      <Col xs={12}>
                        <div className="form-group mb-3">
                          <Label className="form-label" label={"customer_id"} />
                          <Field
                            name="CustomerId"
                            className="react-select-parent"
                            isMulti={true}
                            isSearchable={true}
                            isDisabled={
                              getUserType() === UserType.CustomerAdmin ||
                              getUserType() === UserType.CustomerUser
                                ? true
                                : false
                            }
                            isLoading={false}
                            isClearable={true}
                            isSelectAsset={+true}
                            placeholder={"customer_id"}
                            invalidcharacter={[" "]}
                            validcharacter={["_"]}
                            options={
                              values?.CustomerId &&
                              values?.CustomerId?.length > 0
                                ? values?.CustomerId?.findIndex(
                                    (item: any) => item.id === -1
                                  ) !== -1
                                  ? [props.CustomerIdOptions[0]]
                                  : props.CustomerIdOptions.filter(
                                      (item: any) => item.id !== -1
                                    )
                                : props.CustomerIdOptions ?? []
                            }
                            // options={
                            // UserType.CustomerAdmin === getUserType() &&
                            // transactionReportType ===
                            //   TransactionReportTypeEnum.PAYMENT_WISE
                            //   ? IdOptions.filter((e) => e.Id > 0)
                            //   : IdOptions
                            // }
                            as={FormikFormInputMultipleSelect}
                          />
                        </div>
                      </Col>
                    )}

                    <Col xs={12}>
                      <div className="form-group mb-3">
                        <Label
                          className="form-label"
                          required={true}
                          label="report_name"
                        />
                        <Field
                          data-testid="testFileName"
                          className="form-control"
                          name="FileName"
                          type="text"
                          validcharacter={["-", "_", "@", "#", "$", "."]}
                          placeholder="report_name"
                          as={FormikFormInput}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <Label
                          className="form-label"
                          required={true}
                          label="action_type"
                        />
                        <Field
                          className="form-control"
                          name="ActionType"
                          placeholder="action_type"
                          type="number"
                          as={FormikFormSelectField}
                          typeofoptionid="number"
                          options={reportTypeOptions}
                        />
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <div className="modal-footer border-0">
                  <div className="m-auto">
                    <LoaderButton
                      type="submit"
                      isLoading={actionInProgress}
                      disabled={actionInProgress}
                      text={
                        "generate_" +
                        (values.ActionType === 0
                          ? "pdf"
                          : values.ActionType === 1
                          ? "csv"
                          : values.ActionType === 3
                          ? "excel"
                          : "view")
                      }
                    />
                    <Button
                      variant="btn-secondary bg-light btn-light ms-2"
                      onClick={onModalClosed}
                    >
                      <FormattedMessage id="button_cancel" />
                    </Button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
};

export default ReportsFilterForm;
